// Footer link accordions: collapsed by default below 620px, always expanded at/above it.
// 620px is where candells-footer.css leaves the single-column stack for two columns.
(function () {
  var QUERY = '(min-width: 620px)';

  function sync() {
    var isDesktop = window.matchMedia(QUERY).matches;
    document.querySelectorAll('.candells-footer-accordion').forEach(function (details) {
      details.open = isDesktop;
    });
  }

  document.addEventListener('DOMContentLoaded', sync);
  window.matchMedia(QUERY).addEventListener('change', sync);
})();
